/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RollType = {
    Normal: 'NORMAL',
    Disadvantage: 'DISADVANTAGE',
    Advantage: 'ADVANTAGE'
} as const;
export type RollType = typeof RollType[keyof typeof RollType];

